import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import EventForm from '@/components/EventForm'
import type { Event } from '@/types'

type Props = {
  event: Event
  dress_codes: string[]
  causes: string[]
}

export default function AdminEventsEdit({ event, dress_codes, causes }: Props) {
  return (
    <>
      <Head title={`Admin - Edit ${event.title}`} />
      <EventForm event={event} dressCodes={dress_codes} causes={causes} actionUrl="/admin/events" isAdmin />
    </>
  )
}

AdminEventsEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
